import config from '@/config/app';

export default {
    guest(to, from, next) {
        const authData = JSON.parse(localStorage.getItem(config.APP_VERSION));

        const isAuthenticated = authData ? authData.auth.authenticationStatus : false;

        next(!isAuthenticated ? true : { path: '/profile?selected=profile' });
    },

    user(to, from, next) {
        let accessToken = '';

        let storeData = JSON.parse(localStorage.getItem(config.APP_VERSION));

        if (Object.keys(storeData).length) {
            let authData = storeData.auth;

            if (Object.keys(authData).length) {
                accessToken = authData.authenticationDetails.access_token;
            }
        }

        const isAuthenticated = !!accessToken;

        next(
            isAuthenticated ?
                true :
                {
                    path: '/signin',
                    query: {
                        redirect: to.name
                    }
                }
        );
    }
};
